import styled, { css } from 'styled-components';

interface CardProps {
  isSelected: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin: 1rem 0;
`;

export const Card = styled.div<CardProps>`
  display: flex;
  align-items: center;
  padding: 1rem;
  border: 2px solid ${props => (props.isSelected ? '#2185d0' : '#e1e1e1')};
  border-radius: 8px;
  cursor: pointer;
  background-color: ${props => (props.isSelected ? '#f8fffe' : '#ffffff')};
  transition: all 0.2s ease;

  &:hover {
    border-color: #2185d0;
    background-color: #f8fffe;
  }

  ${props =>
    props.isSelected &&
    css`
      box-shadow: 0 2px 8px rgba(33, 133, 208, 0.2);
    `}
`;

export const Input = styled.input`
  margin-right: 1rem;
  transform: scale(1.2);
`;

export const Content = styled.div`
  flex: 1;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  h2 {
    margin: 0;
    color: #2c3e50;
    font-size: 1.2rem;
  }

  p {
    margin: 0.25rem 0;
    color: #7f8c8d;
  }
`;

export const Table = styled.table`
  width: 100%;

  td {
    padding: 0.25rem 0;
    font-size: 0.9rem;
  }
`;

